<template>
  <div>
    <div class="overlayLoader" v-if="loader">
      <md-progress-spinner
        :md-diameter="90"
        class="md-accent spinner-postion"
        :md-stroke="7"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <b-row>
     

      <div class="md-layout" :class="{ 'rfp-upload-body': formName === 'rfpUploadExcel' }">
        <div
         v-if="!rfpBoqError"
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60"
        >
          <b-alert
            :variant="isSuccess ? 'info' : 'danger'"
            :show="showAlert"
            dismissible
            fade
            @dismissed="showAlert = false"
            >{{ responseMsg }}
          </b-alert>
        </div>
        <div v-if="rfpBoqError" md="8" style="background-color: pink; line-height: 0.4; font-size: 12px; padding: 2px;">       
        <p class="mt-2" v-for="(error, index) in responseMsg.split('\n')" :key="index">
  {{ error }}
</p>
      </div>
      </div>
      <slot></slot>

      <template v-if="formName !== 'rfpUploadExcel'">
        <b-row>
          <b-col>
            <input
              type="file"
              ref="file"
              id="FileUpload1"
              style="display: none"
              @change="selectFile()"
            />
            <md-button
              class="md-info"
              style="margin-left: 15px"
              @click="browseFile()"
              >Add Files..</md-button
            >
            <md-button
              class="md-warning"
              style="margin-left: 5px"
              @click="uploadFile()"
              >Start Upload</md-button
            >
          </b-col>
        </b-row>
        <div class="md-layout-item" style="margin-top: 5px !important">
          <b-table
            striped
            hover
            outlined
            :items="uploadExcelData"
            :fields="uploadExcelFields"
            show-empty
            class="bg-white font-fix"
            sticky-header
          >
            <template #cell(excel_name)="data">
              <a
                href="#"
                @click="showExcelDetails(true, data.item, data.index)"
                >{{ data.item.excel_name }}</a
              >
            </template>
            <template #cell(delete)="data">
              <div
                @click="removeRow(data.index, data.item.s_no)"
                v-if="data.item.s_no > 0"
              >
                <md-button class="md-rose">Delete</md-button>
              </div>
            </template>
          </b-table>
        </div>
      </template>

      <div v-if="formName === 'rfpUploadExcel'" class="rfp-upload-body">

        <div class="rfp-section">
          <div class="rfp-section-title">
            <div class="rfp-icon-circle rfp-icon-pink">
              <md-icon>description</md-icon>
            </div>
            <div class="rfp-section-heading">
              <h5>
                Bid Document
                <span class="rfp-badge rfp-badge-mandatory">(Mandatory)</span>
              </h5>
              <p>Upload the RFP bid document in Excel format.</p>
            </div>
          </div>

          <div class="rfp-actions">
            <input
              type="file"
              ref="file"
              id="FileUpload1"
              style="display: none"
              @change="selectFile()"
            />
            <md-button
              class="md-info rfp-btn-add"
              @click="browseFile()"
            >
              <md-icon>add</md-icon> Add Files..
            </md-button>
            <md-button class="md-warning rfp-btn-upload" @click="uploadFile()">
              <md-icon>file_upload</md-icon> Start Upload
            </md-button>
          </div>

          <div class="md-layout-item" style="margin-top: 5px !important">
            <b-table
              striped
              hover
              outlined
              bordered
              :items="uploadExcelData"
              :fields="rfpBidFields"
              show-empty
              class="bg-white font-fix rfp-table rfp-grid-table"
              sticky-header
            >
              <template #cell(excel_name)="data">
                <a
                  href="#"
                  @click="showExcelDetails(true, data.item, data.index)"
                  >{{ data.item.excel_name }}</a
                >
              </template>
            </b-table>
          </div>

          <div
            class="md-layout-item"
            style="margin-top: 15px !important"
            v-if="uploadExcelDataForAtachment && uploadExcelDataForAtachment.length > 0"
          >
            <b-table
              hover
              outlined
              bordered
              :items="uploadExcelDataForAtachment"
              :fields="uploadExcelFieldsForAttachment"
              class="bg-white font-fix rfp-table rfp-grid-table"
              sticky-header
            >
              <template #cell(s_no)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(original_file_name)="data">
                <a
                  target="_blank"
                  :href="
                    downloadDocUrl +
                      '/download/' +
                      data.item.doc_detail_id +
                      '?token=' +
                      openKmAuth
                  "
                  v-if="data.item.doc_detail_id !== 0"
                >
                  {{ data.item.original_file_name }}
                </a>
                <span v-else>{{ data.item.original_file_name }}</span>
              </template>
            </b-table>
          </div>
        </div>

        <div class="rfp-section">
          <div class="rfp-section-title">
            <div class="rfp-icon-circle rfp-icon-purple">
              <md-icon>description</md-icon>
            </div>
            <div class="rfp-section-heading">
              <h5>
                Additional Document
                <span class="rfp-badge rfp-badge-optional">(Optional)</span>
              </h5>
              <p>Upload any supporting documents if required.</p>
            </div>
          </div>

          <p v-if="!bidHeaderId" class="rfp-additional-doc-hint">
            Upload the bid document first to add additional documents.
          </p>
          <div class="rfp-additional-doc-wrap">
            <uploadDocument
            v-if="openAdditionalDoc"
            ref="additionalDoc"
            :wfHdrId="bidHeaderId"
            :openKmAuth="openKmAuth"
            :propMenuId="menuSubmenuAttachment.menuId"
            :PropSubMenuId="menuSubmenuAttachment.submenuId"
            :approval_status="'DRAFT'"
            :isBidSubmitted="isBidSubmitted"
            :beforeUpload="beforeAdditionalDocUpload"
            :beforeDelete="beforeAdditionalDocDelete"
            formName="rfpQuotation"
            @updateStatusFlag="refreshBidDocumentTable"
          />
          </div>

          <p class="rfp-file-restrictions">
            *Maximum file size 20 MB<br />
            *only pdf, jpg, jpeg, png, zip, excel file allowed
          </p>
        </div>
      </div>
    </b-row>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="wide-modal"
      v-model="showExcelDetailsModal"
      @hidden="showExcelDetails(false)"
      title="Upload Excel Details"
    >
      <ExcelDetails
        :excelRowDtl="excelRowDtl"
        @closeExcelDetail="closeExcelDetail"
        :recordId="recordId"
        :formName="formName"
        :excelProcess="excelProcess"
        :menuSubmenuIdExcelUploader="menuSubmenuIdExcelUploader"
      ></ExcelDetails>
    </b-modal>
  </div>
</template>

<script>
import ExcelDetails from "./ExcelDetails.vue";
import { required } from "vuelidate/lib/validators";
import appStrings from "../utility/string.utility";
import uploadDocument from "./uploadDocument.vue"
import URL_UTILITY from "../utility/url.utility.js";
export default {
  name: "uploadExcel",
  props: [
    "formName",
    "propMenuId",
    "PropSubMenuId",
    "wfHdrId",
    "rfpHdrId",
    "negotiationVendorId",
    "rfpVendorId",
    "negotiationHeaderId",
    "rfpHdrDetails"
  ],
  components: {
    ExcelDetails,
    uploadDocument
  },
  data() {
    return {
      loader: false,
      isSuccess: false,
      showAlert: false,
      respMessage: null,
      uploadExcelData: [],
      selectedObjectData: {
        le_id: null,
        le_name: null,
        nfa_cat_vset: null,
        nfa_cat: null,
        nfa_sub_cat_vset: null,
        nfa_sub_cat: null,
      },
      uploadExcelFields: [
        {
          key: "s_no",
          label: "Serial No.",
        },
        {
          key: "excel_name",
        },
        {
          key: "sheet_name",
        },
        {
          key: "row_uploaded",
        },
        {
          key: "mapped_column",
        },
        {
          key: "updated_by",
        },
        {
          key: "updation_date",
        },
        {
          key: "delete",
        },
      ],
      rfpBidFields: [
        {
          key: "s_no",
          label: "Sl. No.",
          thClass: "text-center",
          class: "rfp-col-sno",
        },
        {
          key: "excel_name",
          label: "File Name",
          thClass: "text-center",
          class: "rfp-col-file-name",
        },
        {
          key: "sheet_name",
          label: "Sheet Name",
          thClass: "text-center",
          class: "rfp-col-file-name",
        },
        {
          key: "updation_date",
          label: "Uploaded On",
          thClass: "text-center",
          class: "rfp-col-uploaded-on",
        },
      ],
      menuId: null,
      subMenuId: null,
      selectedFilesArr: [],
      recordId: null,
      excelImportHdrId: null,
      showExcelDetailsModal: false,
      excelRowDtl: null,
      excelProcess: {
        value: null,
        text: null,
      },
      responseMsg: null,
      menuSubmenuIdExcelUploader: {
        menuId: null,
        submenuId: null,
      },
      menuSubmenuBidHeader: {
        menuId: null,
        submenuId: null,
      },
      uploadDocList: [],
      userId: null,
      rfpBoqError: false,
      uploadExcelDataForAtachment: [],
      uploadExcelFieldsForAttachment: [
        {
          key: "s_no",
          label: "Sl. No.",
          thClass: "text-center",
          class: "rfp-col-sno",
        },
        {
          key: "original_file_name",
          label: "File Name",
          thClass: "text-center",
          class: "rfp-col-file-name",
        },
        {
          key: "creation_date",
          label: "Uploaded On",
          thClass: "text-center",
          class: "rfp-col-uploaded-on",
        },
      ],
      menuSubmenuRfpBoqExcel: {
        menuId: null,
        submenuId: null,
      },
      menuSubmenuAttachment: {
        menuId: null,
        submenuId: null,
      },
      bidHeaderId: null,
      openKmAuth: null,
      openAdditionalDoc:false,
      downloadDocUrl: URL_UTILITY.getDocumentDownloadUrl,
      draftRequest: null,
    };
  },
  computed: {
    isBidSubmitted() {
      return !!this.rfpHdrDetails && this.rfpHdrDetails.bidStatus === "SUBMIT";
    },
  },
  validations: {
    excelProcess: {
      value: { required },
      text: { required },
    },
  },
  mounted() {
    this.userId = JSON.parse(sessionStorage.getItem("userId"));
    this.setMenuSubmenuId();
    this.recordId = this.wfHdrId;
    this.getBidHeaderId();
    this.menuSubmenuIdExcelUploader = {
      menuId: this.propMenuId,
      submenuId: this.PropSubMenuId,
    };
  },
  methods: {
    selectFile() {
      this.selectedFilesArr.push(this.$refs.file.files);
      this.saveFileToTempTable(this.$refs.file.files.item(0));
      this.uploadDocList.push({
        fileRef: this.$refs.file.files,
        file_name: this.$refs.file.files[0].name,
        // leId: this.selectedObjectData.le_id,
        // leName: this.selectedObjectData.le_name,
        categoryCode: this.selectedObjectData.nfa_cat_vset,
        categoryName: this.selectedObjectData.nfa_cat,
        subcategoryCode: this.selectedObjectData.nfa_sub_cat_vset,
        subcategoryName: this.selectedObjectData.nfa_sub_cat,
        comments: "",
        version: 0,
        file_size: this.formatBytes(this.$refs.file.files[0].size),
        action: null,
        docDetailId: 0,
      });
    },
    browseFile() {
      if (this.formName === "rfpUploadExcel") {
        const hasExistingFile =
          this.uploadExcelData.length >= 1 ||
          (this.uploadExcelDataForAtachment &&
            this.uploadExcelDataForAtachment.length > 0);
        if (this.isBidSubmitted) {
          const confirmDraft = window.confirm(
            "A bid document has already been uploaded. Uploading a new document will replace the existing file."
          );
          if (!confirmDraft) {
            return;
          }

          this.saveDraftForDocChange()
            .then(() => {
              this.clearPendingBidSelection();
              this.refreshDocumentTables();
              this.$refs.file.click();
            })
            .catch((err) => {
              this.showAlert = true;
              this.isSuccess = false;
              this.responseMsg =
                (err && err.message) || "Unable to move the bid back to Draft";
            });
          return;
        }
        if (hasExistingFile) {
          const confirmUpdate = window.confirm(
            "A bid document has already been uploaded. Uploading a new document will replace the existing file."
          );
          if (!confirmUpdate) {
            return;
          }
          this.deleteExistingBidDocuments(
            (this.uploadExcelDataForAtachment || []).map(
              (doc) => doc.doc_detail_id
            )
          );
          this.moveBidToDraft().catch((err) => {
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg =
              (err && err.message) || "Unable to move the bid back to Draft";
          });
          this.clearPendingBidSelection();
        }
      }
      this.$refs.file.click();
    },
    clearPendingBidSelection() {
      this.selectedFilesArr = [];
      this.uploadDocList = [];
      this.uploadExcelData = [];
      this.uploadExcelDataForAtachment = [];
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    uploadFile() {
      if (this.uploadExcelData.length === 0) {
        alert("Please add file");
      } else {
        if (this.formName === "rfpUploadExcel") {
          this.excelUploadRfp();
        }
      }
    },
    excelUploadRfp() {
      const payload = {
        excel_import_hdr_id: this.uploadExcelData[0].excel_improt_hdr_id,
        menu_id: this.propMenuId,
        sub_menu_id: this.PropSubMenuId,
        rfp_header_id: this.rfpHdrId,
        negotiation_vendor_id: this.negotiationVendorId,
      };
      this.createDraftIfSubmitted()
        .then(() => {
          this.loader = true;
          return this.$store.dispatch("vendor/addUploadRfpExcelList", payload);
        })
        .then((response) => {
          this.loader = false;
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 2000);
          if (response.status === 200) {
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            this.uploadExcelData = [];
            this.getBidHeaderId().then(() => this.getOpenKmAuthenticateToken());
          } else {
            this.isSuccess = false;
            this.rfpBoqError = true;
            this.responseMsg = response.data.message;
          }
        })
        .catch((err) => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = (err && err.message) || "Something went wrong";
        });
    },
    createDraftIfSubmitted() {
      if (this.draftRequest) {
        return this.draftRequest;
      }
      if (!this.isBidSubmitted) {
        return Promise.resolve();
      }
      this.draftRequest = this.saveBidAsDraft(true)
        .finally(() => {
          this.draftRequest = null;
        });
      return this.draftRequest;
    },

    moveBidToDraft() {
      if (
        !this.bidHeaderId ||
        !this.rfpHdrDetails ||
        this.rfpHdrDetails.bidStatus === "DRAFT"
      ) {
        return Promise.resolve();
      }
      return this.saveBidAsDraft(false);
    },

    // Document actions on a submitted bid (Bid Document > Add Files,
    // Additional Document > Start Upload / Delete) move it back to Draft with a
    // fresh header and no BOQ details.
    saveDraftForDocChange() {
      if (this.draftRequest) {
        return this.draftRequest;
      }
      const payload = {
        bid_hdr_id: 0,
        negotiation_hdr_id: this.negotiationHeaderId,
        negotiation_vendor_id: this.negotiationVendorId,
        rfp_header_id: this.rfpHdrId,
        version: 0,
        status: "DRAFT",
        rfp_vendor_bid_boq_dtls: [],
      };
      this.draftRequest = this.postBidDraft(payload).finally(() => {
        this.draftRequest = null;
      });
      return this.draftRequest;
    },

    saveBidAsDraft(newVersion) {
      this.loader = true;
      return this.$store
        .dispatch("vendor/getRfpBoqData", { bid_hdr_id: this.bidHeaderId })
        .then((resp) => {
          const existingDtls =
            resp.status === 200 && resp.data.data.rfp_vendor_bid_boq_dtls
              ? resp.data.data.rfp_vendor_bid_boq_dtls
              : [];
          const payload = {
            bid_hdr_id: newVersion ? 0 : this.bidHeaderId,
            negotiation_hdr_id: this.negotiationHeaderId,
            negotiation_vendor_id: this.negotiationVendorId,
            rfp_header_id: this.rfpHdrId,
            version: 0,
            status: "DRAFT",
            rfp_vendor_bid_boq_dtls: existingDtls.map((dtl) => ({
              boq_bid_id: newVersion ? 0 : dtl.boq_bid_id || 0,
              boq_id: dtl.boq_id,
              unit_price: dtl.unit_price,
              remarks: dtl.remarks,
              location_id: dtl.location_id,
              exc_boq: dtl.exc_boq,
            })),
          };
          return this.postBidDraft(payload);
        })
        .catch((err) => {
          this.loader = false;
          throw err;
        });
    },

    postBidDraft(payload) {
      this.loader = true;
      return this.$store
        .dispatch("vendor/postRfpBoqData", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status !== 200) {
            throw new Error(
              (resp.data && resp.data.message) ||
                "Unable to move the bid back to Draft"
            );
          }
          this.bidHeaderId = resp.data.data.bid_hdr_id;
          this.recordId = this.bidHeaderId;
          this.rfpHdrDetails.bidStatus = resp.data.data.status || "DRAFT";
        })
        .catch((err) => {
          this.loader = false;
          throw err;
        });
    },
    saveFileToTempTable(fileName) {
      let formData = new FormData();
      formData.append("file", fileName);
      formData.append("menu_id", this.propMenuId);
      formData.append("sub_menu_id", 0);
      if (this.rfpHdrId) {
        formData.append("record_id", this.rfpHdrId ? this.rfpHdrId : null);
      }
      this.loader = true;
      this.$store
        .dispatch("vendor/addUploadExcelList", formData)
        .then((response) => {
          this.loader = false;
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 2000);
          if (response.status === 200) {
            const results = response.data.data;
            this.excelImportHdrId = results[0].excel_improt_hdr_id;
            if (this.formName === "NFA_APPROVAL") {
              this.uploadExcelData = results.splice(0, 1);
            } else {
              this.uploadExcelData = results;
            }
            this.isSuccess = true;
            this.responseMsg = response.data.message;
          } else {
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    removeRow(index) {
      this.uploadExcelData.splice(index, 1);
    },
    showExcelDetails(flag, rowData, index) {
      this.showExcelDetailsModal = flag;
      this.excelRowDtl = rowData;
      this.sheetIndex = index;
    },
    closeExcelDetail(columns) {
      if (columns || columns === 0) {
        this.uploadExcelData[this.sheetIndex].mapped_column = columns;
      }
      this.showExcelDetails(false);
    },
    uploadExcelDocument() {
      const filterDocData = this.uploadDocList.filter(
        (data) => data.docDetailId === 0
      );
      if (filterDocData.length > 0) {
        filterDocData.forEach((data) => {
          let formData = new FormData();
          formData.append("file", data.fileRef.item(0));
          formData.append("token", this.openKmAuth);
          formData.append("doc_detail_id", 0);
          formData.append("menu_id", this.menuSubmenuBidHeader.menuId);
          formData.append("sub_menu_id", this.menuSubmenuBidHeader.submenuId);
          // formData.append("le_id", null);
          formData.append("record_id", this.recordId);
          this.loader = true;
          this.$store
            .dispatch("uploadDocument/uploadFile", formData)
            .then((response) => {
              this.loader = false;
              this.showAlert = true;
              if (response.status === 200) {
                alert("Documnt Uploaded Successfully!");
            this.getUploadedDocDtlForRfpBoqExcel();
              } else {
                alert("Something went wrong while uploading document");
              }
            })
            .catch(() => {
              this.loader = false;
            });
        });
      }
    },
    getOpenKmAuthenticateToken() {
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getOpenKmAuthenticate")
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            this.getUploadedDocDtl();
          } else {
            alert(appStrings.DEPENDENTVSETMSG.DEFAULTMSG);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    setMenuSubmenuId() {
      const menuBidHeader = JSON.parse(sessionStorage.getItem("rfpBidHdr"));
      this.menuSubmenuBidHeader = {
        menuId: menuBidHeader.menu_id,
        submenuId: menuBidHeader.sub_menu_id,
      };
      const rfpBoqExcel = JSON.parse(sessionStorage.getItem("rfpBoqExcelDoc"));
      this.menuSubmenuRfpBoqExcel = {
        menuId: rfpBoqExcel.menu_id,
        submenuId: rfpBoqExcel.sub_menu_id,
      };

      const additionalDoc = JSON.parse(sessionStorage.getItem("rfpAttachment"));
      this.menuSubmenuAttachment = {
        menuId: additionalDoc.menu_id,
        submenuId: additionalDoc.sub_menu_id,
      };
    },
    getUploadedDocDtl() {
      const payload = {
        _page: 0,
        _limit: 1000,
        menu_id: this.menuSubmenuBidHeader.menuId,
        sub_menu_id: this.menuSubmenuBidHeader.submenuId,
        record_id: this.recordId,
        user_id: this.userId,
      };
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getUploadedDocDtl", payload)
        .then((response) => {
          this.loader = false;
          this.$store.dispatch("shared/setLoader", false);
          if (response.status === 200) {
            const staleDocIds = response.data.data.page.map(
              (doc) => doc.doc_detail_id
            );
            this.deleteDocuments(staleDocIds).then(() =>
              this.uploadExcelDocument()
            );
          }
        })
        .catch(() => {
          this.loader = false;
          this.$store.dispatch("shared/setLoader", false);
        });
      this.eventBus.$emit("totalUploadedDocumentRows", this.totalRows);
    },
    deleteExistingBidDocuments(docDetailIds) {
      if (docDetailIds.length === 0) {
        return;
      }
      const withToken = this.openKmAuth
        ? Promise.resolve()
        : this.$store
            .dispatch("uploadDocument/getOpenKmAuthenticate")
            .then((response) => {
              if (response.status !== 200) {
                throw new Error(appStrings.DEPENDENTVSETMSG.DEFAULTMSG);
              }
              this.openKmAuth = response.data.data.token;
            });
      withToken
        .then(() => this.deleteDocuments(docDetailIds))
        .catch((err) => {
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg =
            (err && err.message) || "Unable to remove the old bid document";
        });
    },
    deleteDocuments(docDetailIds) {
      if (docDetailIds.length === 0) {
        return Promise.resolve();
      }
      this.loader = true;
      return Promise.all(
        docDetailIds.map((docDetailId) =>
          this.$store
            .dispatch("vendor/deleteOpenKmDoc", {
              docDetailId: docDetailId,
              token: this.openKmAuth,
            })
            .catch(() => null)
        )
      ).then(() => {
        this.loader = false;
      });
    },
    getBidHeaderId() {
      const payload = {
        _page: 0,
        _limit: 1000,
        rfp_header_id: this.rfpHdrId,
        rfp_vendor_id: this.rfpVendorId,
        negotiation_hdr_id: this.negotiationHeaderId,
      };
      this.loader = true;
      return this.$store
        .dispatch("vendor/getRfpLocationDetails", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.bidHeaderId = result[0].bid_hdr_id ? result[0].bid_hdr_id : null;
            this.recordId = this.bidHeaderId;
            this.getUploadedDocDtlForRfpBoqExcel();
            if (this.bidHeaderId && !this.openAdditionalDoc) {
              this.getOpenKmAuthenticateUploadDocument();
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    makeToast(content, variant) {
      this.$bvToast.toast(content, {
        title: "Alert",
        variant: variant,
        solid: true,
        toaster: "b-toaster-top-center",
        appendToast: true,
        toastClass: "custom-toast",
      });
    },
    refreshBidDocumentTable() {
      this.getBidHeaderId();
    },
    beforeAdditionalDocUpload() {
      if (!this.isBidSubmitted) {
        return Promise.resolve(true);
      }
      return this.saveDraftForDocChange().then(() => true);
    },
    beforeAdditionalDocDelete() {

      if (!this.isBidSubmitted) {
        return Promise.resolve(true);
      }

      return this.saveDraftForDocChange()
        .then(() => {
          this.refreshDocumentTables();
          return false;
        })
        .catch((err) => {
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg =
            (err && err.message) || "Unable to move the bid back to Draft";
          return false;
        });
    },
    refreshDocumentTables() {
      this.getUploadedDocDtlForRfpBoqExcel();
      this.refreshAdditionalDocTable();
    },
    refreshAdditionalDocTable() {
      this.$nextTick(() => {
        const additionalDoc = this.$refs.additionalDoc;
        if (additionalDoc && additionalDoc.getUploadedDocDtl) {
          additionalDoc.getUploadedDocDtl();
        }
      });
    },
    getUploadedDocDtlForRfpBoqExcel() {
      if (!this.menuSubmenuRfpBoqExcel || !this.recordId || !this.userId) {
        return;
      }
      const payload = {
        _page: 0,
        _limit: 1000,
        menu_id: this.menuSubmenuRfpBoqExcel.menuId,
        sub_menu_id: this.menuSubmenuRfpBoqExcel.submenuId,
        record_id: this.recordId,
        user_id: this.userId,
      };
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getUploadedDocDtl", payload)
        .then((response) => {
          this.loader = false;
          this.$store.dispatch("shared/setLoader", false);
          if (response.status === 200) {
            this.uploadExcelDataForAtachment = response.data.data.page || [];
            if (response.data.data.page.length > 0) {
              this.docDetailId = response.data.data.page[0].doc_detail_id;
            }
          }
        })
        .catch(() => {
          this.loader = false;
          this.$store.dispatch("shared/setLoader", false);
        });
      this.eventBus.$emit("totalUploadedDocumentRows", this.totalRows);
    },
    getOpenKmAuthenticateUploadDocument() {
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getOpenKmAuthenticate")
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            this.openAdditionalDoc = true;
          } else {
            alert(appStrings.DEPENDENTVSETMSG.DEFAULTMSG);
          }
        })
        .catch((err) => {
          this.loader = false;
          alert((err && err.message) || appStrings.DEPENDENTVSETMSG.DEFAULTMSG);
        });
    },
  },
};
</script>
<style scoped>
.section-bordered-box {
  border: 1px solid #d7d7d7;
  border-radius: 6px;
  padding: 12px 15px;
  margin-top: 10px;
  background-color: #ffffff;
}

.bid-document-header {
  margin-bottom: 8px;
}

.bid-document-header h3 {
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
  font-weight: bold;
}

/* ============================================================ */
/* Styles for the rfpUploadExcel UI only (matches design mock)   */
/* ============================================================ */
.rfp-upload-header {
  width: 100%;
  background: linear-gradient(90deg, #e5136f, #c2185b);
  color: #fff;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px 6px 0 0;
}

.rfp-upload-header h4 {
  margin: 0;
  font-weight: 700;
  font-size: 22px;
}

.rfp-close-icon {
  cursor: pointer;
  font-size: 26px;
  line-height: 1;
}

.rfp-upload-body {
  width: 100%;
  padding: 5px 10px;
}

.rfp-section {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  background-color: #fff;
}

.rfp-section-title {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 16px;
}

.rfp-icon-circle {
  width: 46px;
  height: 46px;
  min-width: 46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rfp-icon-pink {
  background: #fde3ee;
  color: #e5136f;
}

.rfp-icon-purple {
  background: #f1e4fb;
  color: #8e24aa;
}

.rfp-section-heading h5 {
  margin: 0 0 4px 0;
  font-weight: 700;
  color: #1a1a2e;
  font-size: 17px;
}

.rfp-section-heading p {
  margin: 0;
  color: #6c7488;
  font-size: 14px;
}

.rfp-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 1px 10px;
  border-radius: 12px;
  vertical-align: middle;
}

.rfp-badge-mandatory {
  background: #fde3ee;
  color: #e5136f;
}

.rfp-badge-optional {
  background: transparent;
  color: #6c7488;
  font-weight: 500;
}

.rfp-additional-doc-hint {
  color: #6c7488;
  font-size: 14px;
  margin: 0 0 10px 0;
}

.rfp-table >>> thead th {
  background-color: #f6f6f9;
  color: #e5136f;
  font-weight: 700;
}

.rfp-table >>> tbody a {
  color: #e5136f;
  text-decoration: underline;
}

/* Grid look: visible row + column lines, like the design mock */
.rfp-grid-table >>> table {
  border-collapse: collapse;
  border: 1px solid #e3e3e8;
}

.rfp-grid-table >>> thead th,
.rfp-grid-table >>> tbody td {
  border: 1px solid #e3e3e8 !important;
  padding: 10px 14px;
  vertical-align: middle;
}

.rfp-grid-table >>> thead th {
  border-bottom: 1px solid #e3e3e8 !important;
}

.rfp-additional-doc-wrap {
  margin-top: 6px;
}

.rfp-additional-doc-wrap >>> table {
  border-collapse: collapse;
  border: 1px solid #e3e3e8;
}

.rfp-additional-doc-wrap >>> thead th,
.rfp-additional-doc-wrap >>> tbody td {
  border: 1px solid #e3e3e8 !important;
  padding: 10px 14px;
  vertical-align: middle;
}

.rfp-additional-doc-wrap >>> thead th {
  background-color: #f6f6f9;
  color: #e5136f;
  font-weight: 700;
  border-bottom: 1px solid #e3e3e8 !important;
}

.rfp-additional-doc-wrap >>> tbody a {
  color: #e5136f;
  text-decoration: underline;
}

/* Fixed column widths so Sl. No. / File Name / Uploaded By line up and long
   file names wrap instead of being cut off */
.rfp-grid-table >>> table,
.rfp-additional-doc-wrap >>> table {
  table-layout: fixed;
  width: 100%;
}

.rfp-grid-table >>> .rfp-col-sno,
.rfp-additional-doc-wrap >>> .rfp-col-sno {
  width: 80px;
  text-align: center;
}

.rfp-grid-table >>> .rfp-col-file-name,
.rfp-additional-doc-wrap >>> .rfp-col-file-name {
  text-align: left;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.rfp-additional-doc-wrap >>> .rfp-col-uploaded-by {
  width: 22%;
  text-align: left;
  white-space: normal;
  word-break: break-word;
}

.rfp-grid-table >>> .rfp-col-uploaded-on,
.rfp-additional-doc-wrap >>> .rfp-col-uploaded-on {
  width: 20%;
  text-align: left;
}

.rfp-additional-doc-wrap >>> .rfp-col-action {
  width: 90px;
  text-align: center;
}

/* Global .table-b-table-default > div pins header labels to a 120px
   left-aligned box; let them fill the cell so they center */
.rfp-grid-table >>> thead th > div,
.rfp-additional-doc-wrap >>> thead th > div {
  width: auto !important;
  text-align: center !important;
}

.rfp-file-restrictions {
  text-align: right;
  color: #e5136f;
  font-size: 12px;
  margin: 14px 0 0 0;
}
</style>